import React from "react";
import styled from "styled-components";
import { Flex, Icon, utils, Item, Text, ImageView, buildPath } from "@thenounproject/lingo-core";
import Link from "next/link";

const { getColor, getBorderRadius } = utils;

const KitButton = styled(Link)`
  display: inline-block;
  width: 100%;
  padding: 8px;
  border-radius: ${getBorderRadius("default")};
  &:hover {
    background-color: ${getColor("grayLighter")};
  }
`;

const InspectorItemKit: React.FC<{ item: Item }> = ({ item }) => {
  function renderKitImage() {
    return (
      <ImageView
        background="grayLightest"
        borderRadius="4px"
        src={item.kit?.images?.cover}
        cover
        width={40}
        height={40}
        icon="kit"
        iconSize={24}
        iconFill="grayDark"
      />
    );
  }

  let path: string;
  if (item.itemId) {
    path = `/a/${item.item?.shortId ?? item.itemId}`;
  } else if (item.sectionId) {
    path = `/s/${item.section?.shortId ?? item.sectionId}`;
  } else {
    path = `/k/${item.kit?.shortId ?? item.kitId}`;
  }

  const url = buildPath(path, {
    space: { id: item.spaceId },
  });

  return (
    <KitButton href={url}>
      <Flex width="100%" alignItems="center">
        {/* Image - fixed width */}
        {renderKitImage()}

        {/* Text content - flexible, collapsible */}
        <Flex flexDirection="column" flex="1" minWidth="0" textAlign="left" pl="s">
          <Text font="ui.small" truncate>
            {item.section?.name ? item.section?.name : "Untitled page"}
          </Text>
          <Flex alignItems="center" minWidth="0">
            <Text color="grayDarkest" font="ui.tiny" truncate>
              {item.kit?.name}
            </Text>
            {item.item?.data?.viewName || item.item?.data?.name ? (
              <>
                <Icon
                  iconId="navigation.chevron-right"
                  size="12"
                  fill="grayDarkest"
                  flexShrink="0"
                />
                <Text color="grayDarkest" font="ui.tiny" truncate>
                  {item.item?.data?.viewName || item.item?.data?.name}
                </Text>
              </>
            ) : null}
          </Flex>
        </Flex>

        {/* Right icon - fixed width */}
        <Icon iconId="navigation.chevron-right" size="16" flexShrink="0" />
      </Flex>
    </KitButton>
  );
};

export default InspectorItemKit;
